// Route path constants
export const ROUTES = {
  // Authentication
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_EMAIL: '/verify-email',
  CHECK_EMAIL: '/check-email',
  RESET_PASSWORD: '/reset-password',
  ACCEPT_INVITE: '/accept-invite',
  
  // Main App Routes
  DASHBOARD: '/dashboard',
  TIME_ENTRIES: '/time-entries',
  TIMESHEET: '/timesheet',
  PROJECTS: '/projects',
  TASKS: '/tasks',
  REPORTS: '/reports',
  INVOICES: '/invoices',
  TEAM: '/team',
  MESSAGES: '/messages',
  INBOX: '/inbox',
  HELP: '/help',
  PROFILE: '/profile',
  
  // Dynamic Routes
  TASK_DETAIL: '/tasks/:id',
  PROJECT_DETAIL: '/projects/:id',
  USER_DETAIL: '/users/:userId',
  
  // Admin Routes
  USERS: '/users',
  RESOURCE_UTILIZATION: '/resource-utilization',
  RESOURCE_UTIL_PEOPLE: '/resource-utilization/people',
  RESOURCE_UTIL_PROJECTS: '/resource-utilization/projects',
  RESOURCE_UTIL_TIMELINE: '/resource-utilization/timeline',
  RESOURCE_UTIL_INSIGHTS: '/resource-utilization/insights',
  AI_VALIDATION: '/ai-validation',
  ADMIN_DASHBOARD: '/admin-dashboard',
  ATTENDANCE_MANAGEMENT: '/attendance-management',
  LEAVE_BALANCE: '/leave-balance',
  
  // User Management
  PENDING_APPROVAL: '/pending-approval',
  
  // Security & Setup
  TWO_FA_SETUP: '/2fa-setup',
  TWO_FA_SETUP_ONBOARDING: '/2fa-setup-onboarding',
  ONBOARDING: '/onboarding',
  TWO_FACTOR_VERIFICATION: '/two-factor-verification',
  
  // Integrations
  GITHUB_CALLBACK: '/github-callback',
  MICROSOFT_CALLBACK: '/auth/microsoft/callback',
  MICROSOFT_LOGIN_CALLBACK: '/auth/microsoft/callback',
  GITHUB_INTEGRATION: '/github-integration',
  CALENDAR: '/calendar',
  SPOTIFY: '/spotify',
  SPOTIFY_CALLBACK: '/spotify-callback',
  
  // Leave Management
  LEAVE_MANAGEMENT: '/leave-management',
  LEAVE_EMAIL_ACTION: '/leave-email-action',
  
  // Activity & AI
  MY_ACTIVITY: '/my-activity',
  TALK_TO_TICK_SYNC: '/talk-to-tick-sync',
  ADMIN_CHAT_HISTORY: '/admin/chat-history',
  ADMIN_MESSAGE_LOGS: '/admin/message-logs',
  PROMOTIONAL_EMAILS: '/promotional-emails',
  ANNOUNCEMENTS_ADMIN: '/announcements',
  
  // Public share (no auth)
  SHARE: '/share/:token',

  // Root
  ROOT: '/',
};

// Route titles mapping
export const ROUTE_TITLES = {
  [ROUTES.DASHBOARD]: 'Dashboard',
  [ROUTES.TIME_ENTRIES]: 'Time Entries',
  [ROUTES.TIMESHEET]: 'Timesheet',
  [ROUTES.PROJECTS]: 'Projects',
  [ROUTES.TASKS]: 'Tasks',
  [ROUTES.REPORTS]: 'Reports',
  [ROUTES.INVOICES]: 'Invoices',
  [ROUTES.TEAM]: 'Team',
  [ROUTES.MESSAGES]: 'Messages',
  [ROUTES.INBOX]: 'Inbox',
  [ROUTES.HELP]: 'Pulse AI',
  [ROUTES.PROFILE]: 'Profile',
  [ROUTES.ANNOUNCEMENTS_ADMIN]: 'Announcements',
  [ROUTES.CALENDAR]: 'Calendar',
  [ROUTES.LEAVE_MANAGEMENT]: 'Leave Management',
  [ROUTES.USERS]: 'Users',
  [ROUTES.PENDING_APPROVAL]: 'Pending Approval',
  [ROUTES.RESOURCE_UTILIZATION]: 'Resource Utilization',
  [ROUTES.RESOURCE_UTIL_PEOPLE]: 'Resource Utilization · People',
  [ROUTES.RESOURCE_UTIL_PROJECTS]: 'Resource Utilization · Projects',
  [ROUTES.RESOURCE_UTIL_TIMELINE]: 'Resource Utilization · Timeline',
  [ROUTES.RESOURCE_UTIL_INSIGHTS]: 'Resource Utilization · Insights',
  [ROUTES.AI_VALIDATION]: 'AI Validation',
  [ROUTES.TWO_FA_SETUP]: 'Two-Factor Setup',
  [ROUTES.TWO_FA_SETUP_ONBOARDING]: 'Two-Factor Setup',
  [ROUTES.ONBOARDING]: 'Onboarding',
  [ROUTES.TWO_FACTOR_VERIFICATION]: 'Two-Factor Verification',
  [ROUTES.GITHUB_INTEGRATION]: 'GitHub Integration',
  [ROUTES.SPOTIFY]: 'Spotify',
  [ROUTES.MY_ACTIVITY]: 'My Activity',
  [ROUTES.ADMIN_DASHBOARD]: 'Monitoring and Analytics',
  [ROUTES.TALK_TO_TICK_SYNC]: 'Pulse AI',
  [ROUTES.ADMIN_CHAT_HISTORY]: 'Chat History',
  [ROUTES.ADMIN_MESSAGE_LOGS]: 'Message Logs',
  [ROUTES.PROMOTIONAL_EMAILS]: 'Promotional Emails',
};

// Helper function to get page title
export const getPageTitle = (pathname) => {
  // Handle dynamic routes
  if (pathname.startsWith('/tasks/')) return 'Task Detail';
  if (pathname.startsWith('/projects/')) return 'Project Detail';
  if (pathname.startsWith('/users/')) return 'User Detail';
  // Resource Utilization sub-views share the same base chrome; always
  // show the parent title so the header stays stable while the sub-route
  // only swaps the inner view.
  if (pathname.startsWith('/resource-utilization')) return 'Resource Utilization';

  return ROUTE_TITLES[pathname] || '';
};
